// extracted by mini-css-extract-plugin
export var chip = "_ed-0";
export var filterDropdown = "_ed-5";
export var filterItem = "_ed-6";
export var icon = "_ed-1";
export var removeButton = "_ed-3";
export var removeIcon = "_ed-4";
export var separator = "_ed-2";